export { mountAccordions } from './accordion.ts'
export { setupArticlePage } from './articlePage.ts'
